export default __webpack_public_path__ + "static/media/eliseo.3eb5812a.jpg";